export default {
    CONNECTIONS: "Подключения",
    SETTINGS: "Параметры",
    CANCEL: "Отменить",
    SAVE: "Сохранить"
};
